import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "pages/Home";
import { useAuth } from "AuthContext";

import FullMask from "layout/FullMask";
import MessagePage from "components/MessagePage";
import Login from "pages/Login";
import ForgetPassword from "pages/ForgetPassword";

import { Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import Lop1 from "pages/Lop1";

function NotFound({ permission }) {
    useEffect(() => {
        document.title = `hoctot.ai - ${
            permission ? "Không có quyền truy cập" : "Trang không tồn tại"
        }`;
        // eslint-disable-next-line
    }, []);

    const navigate = useNavigate();
    return (
        <MessagePage
            status={permission ? "403" : "404"}
            title="OOPS"
            subTitle={
                permission
                    ? "Bạn không có quyền truy cập vào trang này."
                    : "Trang bạn cố gắng truy cập không tồn tại."
            }
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

export { NotFound };

function Implementing() {
    const navigate = useNavigate();
    return (
        <MessagePage
            icon={<SmileOutlined />}
            title="Chúng tôi đang phát triển tính năng này, bạn vui lòng đợi bản cập nhật trong tương lai nhé!"
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

var setHeaderG;

function Ro({ element, hasHeader = true, allowRole = 0 }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, firstGettingUser } = useAuth();

    if (firstGettingUser) return <FullMask />;
    if (allowRole !== null && !user) {
        navigate(`/login?next=${location.pathname}`);
        return null;
    }
    if (allowRole !== null && user.role > allowRole) {
        return <NotFound permission />;
    }
    setHeaderG(hasHeader);
    return element;
}

export default function AppRoute({ setHeader }) {
    setHeaderG = setHeader;

    return (
        <Routes>
            <Route
                path=""
                element={<Ro element={<Home />} allowRole={100} />}
            />
            {/* base */}
            <Route
                path="/login"
                element={
                    <Ro
                        hasHeader={false}
                        element={<Login />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/forget-password"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ForgetPassword />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/lop-1/:buoi"
                element={
                    <Ro
                        element={<Lop1 />}
                        allowRole={100}
                    />
                }
            />
            <Route
                path="*"
                element={
                    <Ro
                        element={<NotFound />}
                        allowRole={null}
                    />
                }
            />
        </Routes>
    );
}
